import { render, staticRenderFns } from "./supplies-form.vue?vue&type=template&id=a4eb8d56&scoped=true&"
import script from "./supplies-form.vue?vue&type=script&lang=js&"
export * from "./supplies-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4eb8d56",
  null
  
)

export default component.exports